import { Injectable, inject, LOCALE_ID } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Option } from 'declarabid-library';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly document = inject(DOCUMENT);
  private readonly localeId = inject(LOCALE_ID);

  public readonly languages: Option[] = [
    { value: 'es', viewValue: 'ES' },
    { value: 'en', viewValue: 'EN' },
    { value: 'fr', viewValue: 'FR' },
    { value: 'pt', viewValue: 'PT' }
  ];


  public getCurrentLanguage(): string {
    if (this.localeId.startsWith('en')) {
      return 'en';
    }
    if (this.localeId.startsWith('fr')) {
      return 'fr';
    }
    if (this.localeId.startsWith('pt')) {
      return 'pt';
    }
    if (this.localeId.startsWith('es')) {
      return 'es';
    }

    return 'es';
  }

  public changeLanguage(newLanguage: string): void {
    const currentLanguage = this.getCurrentLanguage();

    if (currentLanguage === newLanguage) {
      return;
    }

    localStorage.setItem('preferred_language', newLanguage);
    this.redirectToLanguageVersion(newLanguage);
  }

  private redirectToLanguageVersion(newLanguage: string): void {
    const baseUrl = this.document.location.origin;

    const newUrl = `${baseUrl}/${newLanguage}/`;

    this.document.location.href = newUrl;
  }

  public getLanguageByCode(code: string): Option | undefined {
    return this.languages.find(lang => lang.value === code);
  }

  public getCurrentLanguageOption(): Option {
    const currentLang = this.getCurrentLanguage();
    return this.getLanguageByCode(currentLang) || this.languages[0];
  }
}
